import { normalButtonSx, getSolidButtonSx, getOutlinedButtonSx, getTextButtonSx, minimalButtonSx, smallButtonSx, largeButtonSx, } from '@revdotcom/vaporwave-sx';
export var ButtonSizeSpecs = {
    normal: normalButtonSx,
    small: smallButtonSx,
    large: largeButtonSx,
    minimal: minimalButtonSx,
};
/** A record of the data defining each button type. Keeps the conditional data out of the Button implementation. */
export var ButtonSpecs = {
    solid: getSolidButtonSx,
    outlined: getOutlinedButtonSx,
    text: getTextButtonSx,
};
